var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-croep" },
    [
      _c(
        "div",
        _vm._g(
          { staticClass: "wrapper" },
          ((_obj = {}),
          (_obj[_vm.events.move] = _vm.move),
          (_obj[_vm.events.end] = function() {
            return (_vm.isDragging = false)
          }),
          _obj)
        ),
        [
          _c("img", {
            ref: "image",
            staticClass: "image",
            style: {
              maxHeight: _vm.size + "px",
              opacity: _vm.isDragging ? 1 : 0.7
            },
            attrs: { src: _vm.src, crossorigin: "anonymous" },
            on: _vm._d({ load: _vm.onImageLoad }, [
              _vm.events.start,
              function($event) {
                $event.preventDefault()
                _vm.isDragging = true
              }
            ])
          }),
          _vm._v(" "),
          _vm.isLoaded && !_vm.hasError
            ? _c("c-selector", {
                attrs: {
                  src: _vm.src,
                  selector: _vm.selector,
                  coordinates: _vm.coordinates
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("c-range", {
        attrs: { value: _vm.selector, min: 100, max: _vm.orientedSize },
        on: { input: _vm.range }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }